// =============================================================================
// Ledger amount-column labels
//
// Shared Debit / Credit / Balance headers for every ledger-style table.
// Debit is always left, Credit is always right. All statement kinds use
// plain headings; transaction descriptions explain the entries.
//
// Backend PDF/XLSX renderers and the Bill UI must agree on these strings,
// which is why they live here (same reason as LEDGER_SECTION_LABELS and
// balanceMarkingForStatementKind). Do not restate the headers at a call site.
// =============================================================================
/**
 * `ledger` - a general ledger or a mixed statement (client business + trust
 * share one Debit / Credit pair on raw debit-positive figures). No gloss.
 *
 * `accounts-receivable` - an AR-only account. Invoices debit, payments credit.
 * The third column is the receivable projection (amount owing), not a signed
 * surplus-capable ledger balance.
 *
 * `accounts-payable` - an AP-only account. Payments and credit notes debit,
 * invoices credit. The third column is the payable projection (amount owed),
 * not a signed surplus-capable ledger balance.
 */
export const LEDGER_AMOUNT_COLUMN_LABELS = Object.freeze({
    ledger: {
        debit: 'Debit',
        credit: 'Credit',
        balance: 'Balance',
    },
    'accounts-receivable': {
        debit: 'Debit',
        credit: 'Credit',
        balance: 'Balance',
    },
    'accounts-payable': {
        debit: 'Debit',
        credit: 'Credit',
        balance: 'Balance',
    },
});
export function ledgerAmountColumnLabels(kind) {
    return LEDGER_AMOUNT_COLUMN_LABELS[kind];
}
/** Debit, Credit, Balance - for a band-header row that already has Date / Description. */
export function ledgerAmountColumnHeaderRow(kind) {
    const labels = ledgerAmountColumnLabels(kind);
    return [labels.debit, labels.credit, labels.balance];
}
